
<template>
    <div>

        <v-app-bar app class="navbar no-print">
            <!-- <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon> -->
            <v-btn icon="" to="/">
                <v-icon>mdi-home</v-icon>
            </v-btn>
            <!-- menu -->
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn  v-bind="attrs" v-on="on" color="white">
                      Menu  
                    </v-btn>
                </template>
                <v-list>
                      <v-list-item v-for="(item , index) in navigation_links" :key="index" :to="item.path">
                <v-list-item-content>
                    <v-list-item-title>{{item.title}}</v-list-item-title>
                </v-list-item-content>
                      </v-list-item>
                </v-list>
            </v-menu>
            <v-spacer></v-spacer>

            <v-app-bar-title>{{$store.getters.language.app_name}}</v-app-bar-title>
            <v-spacer></v-spacer>
            <!-- theme to dark -->
            <v-btn icon @click="$vuetify.theme.dark = !$vuetify.theme.dark">
                <v-icon>mdi-lightbulb</v-icon>
            </v-btn>
            <v-btn icon="" @click="logout">

				<v-icon>mdi-logout</v-icon>
			</v-btn>
        </v-app-bar>
        <!-- <v-navigation-drawer v-model="drawer" app :right="$store.getters.language.rtl" >
            <template v-slot:prepend>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="text-center">{{$store.getters.language.app_name}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
            <v-divider class="mt-3"></v-divider>
            <v-list shaped>
                <v-list-item v-for="(item , index) in navigation_links" :key="index" :to="item.path">
                <v-list-item-content>
                    <v-list-item-title>{{item.title}}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            </v-list>
        </v-navigation-drawer> -->
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            drawer: null,
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout')
        }
    },
    computed: {
        languages() {
            return this.$store.getters.languages
        },
        navigation_links() {
            return [
                  {
                        path : '/patients-list',
                        title : 'Data Entry',
                    },
                    {
                        path :'/patients_view-list',
                        title : 'Patients View',
                    },
                  
            
                    {
                        path : '/record_tests-list',
                        title : 'Record Tests',
                    },
            
                    {
                        path : '/records-list',
                        title : 'Records',
                    },
                    {
                        path: '/options',
                        title: 'Options',
                    },
                    // {
                    //     path : '/tests-list',
                    //     title : 'Tests',
                    // },
            
                    // {
                    //     path : '/units-list',
                    //     title : 'Units',
                    // },
                    {
                        path : '/reports-list',
                        title : 'Reports',
                    }
            
            ]
        },

    }

         
}
</script>
        